import { render, staticRenderFns } from "./ArchiveBase.vue?vue&type=template&id=2c82efb3&scoped=true&"
import script from "./ArchiveBase.vue?vue&type=script&lang=js&"
export * from "./ArchiveBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c82efb3",
  null
  
)

export default component.exports